import { CssBaseline, ThemeProvider, createTheme } from '@mui/material'
import FormPreview from './FormPreview'
import type { AssetRenderComponentProps } from '../assetTypes'

const formTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#003223',
      contrastText: '#F1EDE8',
    },
    background: {
      default: '#F1EDE8',
      paper: '#F1EDE8',
    },
    text: {
      primary: '#003223',
      secondary: '#898989',
    },
    divider: '#d9d9d9',
    error: {
      main: '#D31414',
    },
    gray: {
      main: '#808080',
    },
  },
  typography: {
    fontFamily: '"Be Vietnam Pro", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
})

const FormAssetRenderer = ({
  content,
  renderData,
  previewWidth,
  previewHeight,
  reloadToken,
  layout,
  previewSx,
  onLog,
}: AssetRenderComponentProps) => (
  <ThemeProvider theme={formTheme}>
    <CssBaseline />
    <FormPreview
      content={content}
      renderData={renderData}
      previewWidth={previewWidth}
      previewHeight={previewHeight}
      reloadToken={reloadToken}
      previewSx={previewSx}
      layout={layout}
      showLog={false}
      onLog={onLog}
    />
  </ThemeProvider>
)

export default FormAssetRenderer
